import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_checkbox_field = _resolveComponent("checkbox-field")

  return (_openBlock(), _createBlock(_component_checkbox_field, {
    "model-value": $props.modelValue,
    condensed: true,
    "display-name": _ctx.Resources.Checkout.CheckboxRightOfWithdrawalConsentAgreementLabel,
    name: $props.name,
    "onUpdate:modelValue": $options.onInput,
    "data-qa": "right-of-withdrawal-consent-agreement"
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.Resources.Checkout.CheckboxRightOfWithdrawalConsentAgreementMessage), 1 /* TEXT */)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["model-value", "display-name", "name", "onUpdate:modelValue"]))
}